function initDropdownLogic(context = document) {
  const dropdown = context.querySelector('.se-dropdown');
  if (!dropdown) return;

  const nativeSelect = context.querySelector('select.select__select');

  dropdown.querySelector('.se-dropdown-toggle')?.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('open');
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('open');
    }
  });

  dropdown.querySelectorAll('.se-dropdown-item').forEach((item) => {
    item.addEventListener('click', () => {
      const productUrl = item.getAttribute('data-product-url') || item.querySelector('img')?.getAttribute('data-product-url');
      if (!productUrl || !nativeSelect) return;

      const match = Array.from(nativeSelect.options).find(option =>
        option.getAttribute('data-product-url') === productUrl
      );

      if (match) {
        nativeSelect.value = match.value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      dropdown.classList.remove('open');
    });
  });

  context.querySelectorAll('.se-combined-value').forEach((el) => {
    el.addEventListener('click', () => {
      const url = el.getAttribute('data-product-url');
      const target = dropdown.querySelector(`.se-dropdown-item[data-product-url="${url}"]`) ||
        Array.from(dropdown.querySelectorAll('.se-dropdown-item')).find(item =>
          item.querySelector('img')?.getAttribute('data-product-url') === url
        );

      if (target) target.click();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initDropdownLogic();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.querySelector?.('.se-dropdown')) {
          initDropdownLogic(node);
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});